// test2287
(2287 && 0);
